import { render, staticRenderFns } from "./DataAdmin.vue?vue&type=template&id=141177e0&scoped=true&"
import script from "./DataAdmin.vue?vue&type=script&lang=js&"
export * from "./DataAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141177e0",
  null
  
)

export default component.exports